import React, { FC } from 'react';
import { Box, Typography, LinearProgress, useTheme } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

type Props = {
  step: number;
};

const StepProgress: FC<Props> = ({ step }) => {
  const theme = useTheme();

  const iconColor = theme.palette.primary.main;
  const primaryColor = theme.palette.primary.main;

  return (
    <Box display="flex" flexDirection="row" alignItems="center" sx={{ mt: '4vh', width: '100%' }}>
      <Box
        sx={{
          p: 1.5,
          bgcolor: '#F2F4F8',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 24,
          height: 24,
        }}
      >
        <ChevronLeftIcon sx={{ color: iconColor, fontSize: 14 }} />
      </Box>

      <Typography sx={{ fontWeight: 600, fontSize: '16px', ml: '10px', color: primaryColor }}>Etapa {step} de 2</Typography>

      <Box sx={{ width: '12vw', mx: 'auto', transform: 'translateX(-96px)' }}>
        <LinearProgress variant="determinate" value={step === 1 ? 50 : 75} sx={{ '& .MuiLinearProgress-bar': { bgcolor: '#115398' } }} />
      </Box>
    </Box>
  );
};

export default StepProgress;
